<template>
  <div>
    <div class="relative flex">
      <span v-if="hasUnreadMessages && !chatMutedAt" class="w-6 h-6 rounded-full absolute top-0 left-14 bg-yellow-500" />
      <ButtonModule
        prefix="icon-teams-chat text-17"
        class="text-app-color px-10 py-8 rounded-6 anim-color-200"
        :text="isMobile || !showSidebar ? '' : 'chat'"
        :classes="`${isDarkMode ? 'hover:bg-dark-500' : 'hover:bg-menu-hover'}`"
        :has-hover="true"
        @click.stop="openChat"
      />
    </div>
    <Chat
      :show-chat="showChat"
      @close-chat="closeChat"
    />
  </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue'
import { useStore } from 'vuex'

import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import Chat from '@/components/chat/Chat'

import { preventBodyScroll } from '@/core/helper-functions'

export default defineComponent({
  components: { ButtonModule, Chat },

  setup (props) {
    const { state, getters, dispatch } = useStore()
    const showChat = ref(false)

    const isMobile = computed(() => getters.isMobile)
    const isDarkMode = computed(() => getters.isDarkMode)
    const chatMutedAt = computed(() => state.chat.chatMutedAt)
    const hasUnreadMessages = computed(() => state.chat.hasUnreadMessages)
    const showSidebar = computed(() => state.settings.showSidebar)
    const book = computed(() => state.book.book)

    function openChat () {
      preventBodyScroll(true)
      showChat.value = true
      dispatch('updateMessageStatus', { chatId: book.value.chat.id })
    }

    function closeChat () {
      preventBodyScroll(false)
      showChat.value = false
    }

    return {
      // ref
      showChat,
      // computed
      isMobile,
      isDarkMode,
      chatMutedAt,
      showSidebar,
      hasUnreadMessages,
      // function
      openChat,
      closeChat
    }
  }
})
</script>
